import client from './apiClient';
import { objectKeysToCamelCase } from '../helpers/helpers';
export async function getStructureMetadata() {
  const res = await client.get('/structures/structures_metadata');
  return objectKeysToCamelCase(res.data);
}
